import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { Box, FlexBox } from '../box';
import { IconCircle, IconExpandMore } from '../icon';
import { styled } from '../styled';
import { Typography } from '../typography';
const Group = styled(Box)(({ theme }) => ({
    borderBottom: `1px solid ${theme.palette.divider}`
}));
const GroupHeader = styled('button')(({ theme }) => ({
    alignItems: 'center',
    background: 'none',
    border: 0,
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'space-between',
    padding: theme.spacing(2),
    textAlign: 'left',
    width: '100%'
}));
const GroupContent = styled(FlexBox)(({ theme }) => ({
    padding: theme.spacing(0, 2, 2, 5),
    position: 'relative'
}));
const TimelineLine = styled(Box)(({ theme }) => ({
    backgroundColor: theme.palette.divider,
    bottom: theme.spacing(2),
    left: theme.spacing(2.75),
    position: 'absolute',
    top: 0,
    width: 1
}));
const Item = styled(FlexBox)(({ theme }) => ({
    gap: theme.spacing(1.5),
    position: 'relative',
    zIndex: 1
}));
const Marker = styled(FlexBox)(({ theme }) => ({
    alignItems: 'center',
    backgroundColor: theme.palette.background.default,
    color: theme.palette.primary.main,
    flexShrink: 0,
    height: theme.spacing(2),
    justifyContent: 'center',
    marginLeft: theme.spacing(-3),
    width: theme.spacing(2)
}));
const ItemContent = styled(FlexBox)(({ theme }) => ({
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    gap: theme.spacing(1),
    padding: theme.spacing(2),
    width: '100%'
}));
const GroupExpandIcon = styled(IconExpandMore)(({ $expanded }) => ({
    transform: `rotate(${$expanded ? 180 : 0}deg)`,
    transition: 'transform 150ms ease'
}));
export const Timeline = ({ groups, 'data-role': dataRole }) => {
    const [expandedGroups, setExpandedGroups] = React.useState(() => groups.map((group) => group.expanded ?? true));
    const toggleGroup = (index) => {
        setExpandedGroups((expanded) => {
            const nextExpandedGroups = [...expanded];
            const currentExpanded = expanded[index] ?? groups[index]?.expanded ?? true;
            nextExpandedGroups[index] = !currentExpanded;
            return nextExpandedGroups;
        });
    };
    return (_jsx(FlexBox, { stack: true, "data-role": dataRole, width: "100%", children: groups.map((group, groupIndex) => {
            const expanded = expandedGroups[groupIndex] ?? group.expanded ?? true;
            return (_jsxs(Group, { children: [_jsxs(GroupHeader, { "data-role": "timeline-group-header", "aria-expanded": expanded, onClick: () => toggleGroup(groupIndex), type: "button", children: [_jsx(Typography, { variant: "bodyStrong", children: group.label }), _jsx(GroupExpandIcon, { "$expanded": expanded })] }), expanded && (_jsxs(GroupContent, { stack: true, gap: 2, "data-role": "timeline-group-content", children: [_jsx(TimelineLine, {}), group.items.map((item, itemIndex) => (_jsxs(Item, { "data-role": "timeline-item", children: [_jsx(Marker, { children: _jsx(IconCircle, { fontSize: "small" }) }), _jsxs(ItemContent, { stack: true, children: [_jsxs(FlexBox, { gap: 1, hAlign: "space-between", vAlign: "center", children: [_jsx(Typography, { variant: "bodyStrong", children: item.title }), item.timestamp && (_jsx(Typography, { variant: "detail", color: "text.secondary", children: item.timestamp }))] }), item.subtitle && (_jsx(Typography, { variant: "detail", color: "text.secondary", children: item.subtitle })), item.content] })] }, itemIndex)))] }))] }, groupIndex));
        }) }));
};
